import { Button, Grid, Tooltip, Typography } from "@mui/material";
import { useSuperAdminSingleRol } from "../../../context/SuperAdmin/SingleRoleContext";
import LockIcon from "@mui/icons-material/Lock";
import { useAuthContext } from "../../../hooks/Auth";

const SingleRoleDescription = () => {
  const { role, openModal } = useSuperAdminSingleRol();
  const { canAccess } = useAuthContext();
  return (
    <Grid
      container
      sx={{
        padding: 4,
        backgroundColor: "#EEF3F6",
        gap: 3,
      }}
    >
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: 1,
          gap: 2,
        }}
      >
        <Grid item>
          <Typography fontSize={22} sx={{ fontWeight: 700 }}>
            Resumen
          </Typography>
        </Grid>

        {role.es_editable && canAccess("edit:role") ? (
          <Grid item>
            <Button
              variant="outlined"
              onClick={openModal}
              sx={{
                borderRadius: 14,
                border: "1px solid #005559",
                color: "#005559",
                "&:hover": {
                  backgroundColor: "#005559",
                  color: "#EEF3F6",
                },
              }}
            >
              Editar
            </Button>
          </Grid>
        ) : (
          <Tooltip title="Este rol no puede ser editado">
            <LockIcon />
          </Tooltip>
        )}
      </Grid>

      <Grid
        container
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          width: 1,
          gap: 2,
        }}
      >
        <Grid item display={"flex"} gap={2}>
          <Typography fontSize={18} sx={{ fontWeight: 700 }}>
            Nombre:
          </Typography>
          <Typography fontSize={18}>{role.nombre}</Typography>
        </Grid>

        <Grid item display={"flex"} gap={2}>
          <Typography fontSize={18} sx={{ fontWeight: 700 }}>
            Descripción:
          </Typography>
          <Typography fontSize={18}>{role.descripcion}</Typography>
        </Grid>

        <Grid item display={"flex"} gap={2}>
          <Typography fontSize={18} sx={{ fontWeight: 700 }}>
            Organización:
          </Typography>
          <Typography fontSize={18}>{role.organizacion}</Typography>
        </Grid>

        <Grid item display={"flex"} gap={2}>
          <Typography fontSize={18} sx={{ fontWeight: 700 }}>
            Fecha de creación:
          </Typography>
          <Typography fontSize={18}>
            {new Date(role.created_at).toLocaleString()}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SingleRoleDescription;
